import { styles } from './template.scss';
import { styles as textHelpersStyles } from '../../assets/text-helpers.scss';
import { styles as colorHelpersStyles } from '../../assets/color-helpers.scss';
import { renderErrorStateIcon } from '../../utils/widgets.utils';

export const templateCompanyRiskScore = document.createElement('template');

templateCompanyRiskScore.innerHTML = `
  <style>${textHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${styles}</style>
  <div class="wrapper widget-1-3-ratio">
    <h2 class="display-2 widget-title">
      <span id="companyRiskTitle"></span>
      ${renderErrorStateIcon()}
    </h2>

    <div class="content">
        <div class="gauge-container">
          <gz-gauge id='companyRiskGauge' value=''></gz-gauge>
        </div>

        <gz-text id="missingLicense" class="widget-missing-license body-copy" fontSize="12" lineHeight="1.4"></gz-text>

        <ul id="companyRiskList" class="threats-list list-unstyled">
          <li class="gz-data-item gz-data-list-item">
            <div class="gz-data-item--details item-details">
                <div class="gz-data-item--title" gz-list-element="name"></div>
                <span class="gz-data-item--value" gz-list-element="value"></span>
            </div>
            <span class="gz-data-item--delta" gz-list-element="delta"></span>
          </li>

          <li class="gz-data-item gz-data-list-item">

            <div class="gz-data-item--details item-details">
                <div class="gz-data-item--title" gz-list-element="name"></div>
                <span class="gz-data-item--value" gz-list-element="value"></span>
            </div>

           <span class="gz-data-item--delta" gz-list-element="delta"></span>

            </li>
          <li class="gz-data-item gz-data-list-item">
            <div class="gz-data-item--details item-details">
                <div class="gz-data-item--title" gz-list-element="name"></div>
                <span class="gz-data-item--value" gz-list-element="value"></span>
            </div>
            <span class="gz-data-item--delta" gz-list-element="delta"></span>
          </li>
        </ul>
      <gz-loader class="widget-loading" rows="5"></gz-loader>
    </div>
  </div>
`;
